import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useToast } from '@/components/ui/use-toast';
import { label } from '@/utils/label';
import { Organization } from '../types';
import { LabelGroup } from '@/features/label/types';

const QUERY_KEY = 'organizations';
const API_PATH = '/organizer';

export const updateOrganization = (data: Organization): Promise<Organization> => {
  return axios.put(API_PATH, data);
};

type UseUpdateOrganizationOptions = {
  config?: MutationConfig<typeof updateOrganization>;
};

export const useUpdateOrganization = ({ config }: UseUpdateOrganizationOptions) => {
  const { toast } = useToast();

  return useMutation({
    onMutate: async (next: any) => {
      await queryClient.cancelQueries([QUERY_KEY]);

      const prev = queryClient.getQueryData<Organization[]>([QUERY_KEY]);

      queryClient.setQueryData([QUERY_KEY], [...(prev || []), next.data]);

      return { prev };
    },
    onError: (_, __, context: any) => {
      if (context?.prev) {
        queryClient.setQueryData([QUERY_KEY], context.prev);
      }
      toast({
        variant: 'destructive',
        title: label('something_went_wrong', LabelGroup.GLOBAL),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEY]);
      queryClient.refetchQueries([QUERY_KEY]);

      toast({
        variant: 'success',
        title: label('organization_updated', LabelGroup.ORGANIZER_ORGANIZATION_EDIT),
      });
    },
    ...config,
    mutationFn: updateOrganization,
  });
};
